import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { CarrierService } from 'src/app/services/carrier.service';
import { StationService } from 'src/app/services/station.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent implements OnInit {

  showNavigation: boolean;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private stationService: StationService,
    private carrierService: CarrierService
  ) {
    this.showNavigation = false;
  }

  ngOnInit() {

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
      )
      .pipe(
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data),
      )
      .subscribe(event => {
        this.showToolbar(event.showNavBar, event.disableSearchFields);
      });
  }

  showToolbar(showNavBar: boolean, disableSearchFields: any) {

    if (showNavBar === false) {
      this.showNavigation = false;
    } else if (showNavBar === true) {
      this.showNavigation = true;
    } else {
      this.showNavigation = this.showNavigation;
    }

    /* As per Business suggestion, commented out the below logic of disabling of search fields 
    in W&B page when navigated from status page */
    // if (this.showNavigation || (!this.showNavigation && disableSearchFields)) {

    if (!(this.stationService.stations$.getValue().length > 0)) {
      // Get station options
      this.stationService.getStations();
    }

    if (!(this.carrierService.carriers$.getValue().length > 0)) {
      // Get carrier code options
      this.carrierService.getCarrierCodes();
    }

    // }
  }

}
